import { render } from "./CadastroRntrcSolicitacao.vue?vue&type=template&id=46da4ebc&scoped=true"
import script from "./CadastroRntrcSolicitacao.vue?vue&type=script&lang=ts"
export * from "./CadastroRntrcSolicitacao.vue?vue&type=script&lang=ts"

import "./CadastroRntrcSolicitacao.vue?vue&type=style&index=0&id=46da4ebc&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-46da4ebc"

export default script